import '../picture';

export default (context, html) => html`
  <aofl-img id="back-button" src="/assets/templates/back-button/back-button-v1.png" @click="${(e) => context.goBack(e)}" width="32" height="48" alt="back button" role="button"></aofl-img>
`;
